import React, { Component } from "react";
import { Table, Button, Modal, Row, Col, Tooltip, message, Icon } from "antd";
import axios from "axios";
import "./Pages.css";
import AtividadeForm from '../components/AtividadeForm';
import FiltrosForm from '../components/FiltrosForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao, getTipoUsuario } from "../utils/LoginManager";

const dateFormat = 'DD/MM/YYYY'
const { Column } = Table;
const ButtonGroup = Button.Group;


export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    formVisivel: false,
    formFiltroVisivel: false,
    filtros: {
      tipoTela: 'ATIV',
      buscaOrdem: { campo: 'ativ_data_ativ', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaAgruparCidades: 0,
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaAtividade: { key: '0', },
      buscaTipoAtiv: { key: 'X' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    getTipoUsuario().then(tipoUsuario => {
      this.state.filtros.buscaUsuario = {
        key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : usuario.usu_cpf
      }
      this.setState({
        usuario,
        tipoUsuario,
      }, this.getListaRegistros);
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true, qtdePed: 0, qtdeOrc: 0, vlrTotalPed: 0, vlrTotalOrc: 0 });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaPessoa, buscaMunicipio, buscaUsuario, buscaOrdem,
      buscaAtividade, buscaTipoAtiv } = this.state.filtros;

    let ativ_data_ativ_ini = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      ativ_data_ativ_ini = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let ativ_data_ativ_fim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      ativ_data_ativ_fim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/atividades', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          codCliente: buscaPessoa.key,
          cidade: buscaMunicipio.key,
          usuario: buscaUsuario.key,
          atividade: buscaAtividade.key,
          tipoAtividade: buscaTipoAtiv.key,
          ativ_data_ativ_ini,
          ativ_data_ativ_fim,
          print: 0,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };





  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    // console.log('Registro gravar: ', registro);
    let request;
    if (registro.ativ_idf) {
      request = axios.put(`/atividades/update/${registro.ativ_idf}`, registro);
    } else {
      request = axios.post(`/atividades/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Atividade gravada com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      visualizar: false,
      registroSelecionado: {
        ativ_idf: 0,
        ativ_atividade: { key: '1' },
        ativ_data_ativ: moment().format('DD/MM/YYYY'),
        ativ_hora_ini: '00:00',
        ativ_hora_fim: '00:00',
        ativ_data_checkin: '',
        ativ_data_checkout: '',
        ativ_local_checkin: '',
        ativ_local_checkout: '',
        ativ_obs: '',

        ativv_motivo_visita: { key: '3' },
        ativv_idf_venda: 0,
        ativv_cliente: { key: '0' },
        ativv_nome_cliente: '',
        ativv_venda: 0,
        ativr_relatorio: '',

        ativa_km_ini: 0,
        ativa_km_fim: 0,
        ativa_km_rodado: 0,
        ativa_km: 0,
        ativa_qtde_comb: 0,

        ativ_usuario: {
          key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : this.state.usuario.usu_cpf
        },

        listaProdutos: [],
        visualizando: false,
      },
    })

  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/atividades/show/${registro.ativ_idf}`)
      .then(response => {
        const { data } = response;

        data.ativ_data_ativ = moment(data.ativ_data_ativ, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.ativ_hora_ini = data.ativ_hora_ini ? data.ativ_hora_ini : '00:00';
        data.ativ_hora_fim = data.ativ_hora_fim ? data.ativ_hora_fim : '00:00';

        data.ativ_atividade = {
          key: String(data.ativ_atividade),
          label: String(data.ac_descricao),
        }
        data.ativ_usuario = {
          key: String(data.ativ_usuario),
          label: data.usu_nome,
        }

        data.ativv_motivo_visita = {
          key: String(data.ativv_motivo_visita),
          label: String(data.amv_descricao),
        }
        data.ativv_cliente = {
          key: data.ativv_cliente ? String(data.ativv_cliente) : '0',
          label: data.pes_nome ? '[' + String(data.ativv_cliente) + '] ' + data.pes_nome : '',
        }
        data.ativv_idf_venda = data.ativv_idf_venda ? data.ativv_idf_venda : 0;
        data.ativv_nome_cliente = data.ativv_nome_cliente ? data.ativv_nome_cliente : '';
        data.ativv_venda = data.ativv_venda ? data.ativv_venda : 0;
        data.ativr_relatorio = data.ativr_relatorio ? data.ativr_relatorio : '';

        data.ativa_km_ini = data.ativa_km_ini ? data.ativa_km_ini : 0;
        data.ativa_km_fim = data.ativa_km_fim ? data.ativa_km_fim : 0;
        data.ativa_km_rodado = parseFloat(data.ativa_km_ini) > 0 && parseFloat(data.ativa_km_fim) > 0 ? parseFloat(data.ativa_km_fim) - parseFloat(data.ativa_km_ini) : 0;

        data.ativa_km = data.ativa_km ? data.ativa_km : 0;
        data.ativa_qtde_comb = data.ativa_qtde_comb ? data.ativa_qtde_comb : 0;

        data.visualizando = getTemPermissao('AtividadesPage', 'editar') ? false : true;

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/atividades/delete/${registro.ativ_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.ativ_idf === registro.ativ_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };

  onChangeVendedor = event => {
    this.setState({
      buscaUsuario: event.buscaUsuario,
    });
  }

  onBuscar = event => {
    event.preventDefault();
    this.getListaRegistros();
  }






  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {/* <Tooltip title="Localização">
          <Button type="ghost" size="small" onClick={() => this.onAbrirMapaClick(registro)} icon="global" disabled={(registro.ven_latitude) && (registro.ven_latitude) ? false : true} />
        </Tooltip> */}

        {getTemPermissao('AtividadesPage', 'editar') ? (
          <Tooltip title={registro.ven_dt_enviado ? "Visualizar" : "Editar"}>
            <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro, false)} icon={registro.ven_dt_enviado ? "eye" : "edit"} />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro, false)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('AtividadesPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button className="botoesModalFormExcluir" size="small" disabled={registro.ven_dt_enviado ? true : false} onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : (
          <Tooltip title="Excluir">
            <Button className="botoesModalFormExcluir" size="small" disabled={true} onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        )}
      </ButtonGroup>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }


  renderAtividade = (text, registro) => {
    let check;

    if (!registro.ativ_data_checkin) {
      if ((registro.ativ_hora_ini) && (registro.ativ_hora_ini != '00:00')) {
        const date1 = new Date();
        const date2 = moment(registro.ativ_data_ativ).format('DD/MM/YYYY') + ' ' + registro.ativ_hora_ini + ':00';
        if (moment(date1, "DD/MM/YYYY HH:mm:ss").diff(moment(date2, "DD/MM/YYYY HH:mm:ss")) >= 0) {
          check = 0
        } else {
          check = 1
        }
      } else {
        check = 0
      }
    } else if (!registro.ativ_data_checkout) {
      if ((registro.ativ_hora_fim) && (registro.ativ_hora_fim != '00:00')) {
        const date1 = new Date();
        const date2 = moment(registro.ativ_data_ativ).format('DD/MM/YYYY') + ' ' + registro.ativ_hora_fim + ':00';
        if (moment(date1, "DD/MM/YYYY HH:mm:ss").diff(moment(date2, "DD/MM/YYYY HH:mm:ss")) >= 0) {
          check = 0
        } else {
          check = 1
        }
      } else {
        check = 0
      }
    } else {
      check = 0
    }

    return (
      <div>
        {(registro.ativ_data_checkin && registro.ativ_data_checkout) ? (
          <Icon type="check-circle" style={{ marginRight: 5, color: "#10734a" }} />
        ) : (
          check ? (
            <Icon type="calendar" style={{ marginRight: 5, color: "#f9a825" }} />
          ) : (
            <Icon type="close-circle" style={{ marginRight: 5, color: "#b71c1c" }} />
          )
        )}
        <span>{registro.ac_descricao}</span>
      </div>
    )
  };

  renderCliente = (text, registro) => {
    return (
      <span>
        <Icon type={registro.ativv_cliente ? "user" : "user-delete"} style={{ fontSize: 25, marginRight: 5, color: registro.ativv_cliente ? "#10734a" : "#b71c1c" }} />
        <span>{registro.ativv_cliente ? registro.pes_nome : registro.ativv_nome_cliente}</span>
      </span>
    );
  };

  renderUsuario = (usu_nome) => {
    return (
      <span>{usu_nome.substring(0, 10)}</span>
    );
  };

  onAbrirMapaClick = (localizacao) => {
    if (localizacao) {
      window.open("http://maps.google.com/maps?q=" + localizacao, '_blank')
      // window.open("http://maps.google.com/maps?q=" + localizacao, "minhaJanela", "height=400,width=400");
    }
  };

  renderDataCheckIn = (text, registro) => {
    if (registro.ativ_data_checkin) {
      const dataMoment = moment(registro.ativ_data_checkin);
      return (
        <span>
          <Tooltip title="Abrir Localização no Mapa">
            <Icon type="pushpin" style={{ marginRight: 5, color: "#10734a" }} />
            <a onClick={() => this.onAbrirMapaClick(registro.ativ_local_checkin)}>
              {dataMoment.format('DD/MM/YYYY HH:mm')}
            </a>
          </Tooltip>
        </span >
      )
    } else {
      return (
        <span>
          <Icon type="close-circle" style={{ marginRight: 5, color: "#b71c1c" }} />
          <span>SEM CHECK-IN</span>
        </span>
      )
    }
  }

  renderDataCheckOut = (text, registro) => {
    if (registro.ativ_data_checkout) {
      const dataMoment = moment(registro.ativ_data_checkout);
      return (
        <span>
          <Tooltip title="Abrir Localização no Mapa">
            <a
              onClick={() => this.onAbrirMapaClick(registro.ativ_local_checkout)}
            >
              {dataMoment.format('DD/MM/YYYY HH:mm')}
            </a>
          </Tooltip>
        </span>
      )
    } else {
      return (
        <span>
          <Icon type="close-circle" style={{ marginRight: 5, color: "#b71c1c" }} />
          <span>SEM CHECK-OUT</span>
        </span>
      )
    }
  }




  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaAgruparCidades: this.state.filtros.buscaAgruparCidades,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
        buscaAtividade: this.state.filtros.buscaAtividade,
        buscaTipoAtiv: this.state.filtros.buscaTipoAtiv,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado, filtros,
      total, pagina, limite, formFiltroVisivel } = this.state;

    // console.log('AtividadesPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Controle de Atividades dos Vendedores</h2>
        <hr />
        <br />

        <div className="pageFiltro" style={{ height: 70 }}>
          <Row>
            <Col xs={10} style={{ marginTop: -5 }}>
              {(!this.state.tipoUsuario) || (getTemPermissao('AtividadesPage', 'novo')) ? (
                <Button
                  onClick={this.onAdicionarClick}
                  className="pageFiltro-adicionar"
                >
                  Adicionar
                </Button>
              ) : null}

              <Button
                onClick={this.onAbrirFiltroClick}
                className="pageFiltro-filtrar"
                style={{ marginRight: 15 }}
              >
                Filtrar
              </Button>

              <FiltrosForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />
            </Col>
          </Row>

          <AtividadeForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />
        </div>



        <div style={{ marginTop: -30 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            // scroll={{ x: 600 }}
            rowKey={(registro => registro.ativ_idf)}
          >
            <Column
              key="ativ_data_ativ"
              dataIndex="ativ_data_ativ"
              title={this.renderTitulo("Data")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ativ_hora_ini"
              dataIndex="ativ_hora_ini"
              title={this.renderTitulo("Início")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ativ_hora_fim"
              dataIndex="ativ_hora_fim"
              title={this.renderTitulo("Fim")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ativ_atividade"
              dataIndex="ativ_atividade"
              title={this.renderTitulo("Atividade")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderAtividade}
              width={"12%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="ativv_nome_cliente"
              dataIndex="ativv_nome_cliente"
              title={this.renderTitulo("Cliente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderCliente}
              width={"12%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="ativ_obs"
              dataIndex="ativ_obs"
              title={this.renderTitulo("Descrição")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"10%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="ativ_data_checkin"
              dataIndex="ativ_data_checkin"
              title={this.renderTitulo("Check-In")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderDataCheckIn}
              width={"12%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ativ_data_checkout"
              dataIndex="ativ_data_checkout"
              title={this.renderTitulo("Check-Out")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderDataCheckOut}
              width={"12%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="usu_nome"
              dataIndex="usu_nome"
              title={this.renderTitulo("Usuário")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderUsuario}
              width={"8%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>Ações</div>}
              render={this.renderAcoes}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/AtividadesPage.js